module.exports = __webpack_public_path__ + "static/media/cookies.492f80b3.svg";